import React, { useEffect, useContext, useMemo, useState } from "react";
import {
    Link,
    useNavigate,
    useSearchParams,
    useParams,
} from "react-router-dom";
import { useSelector } from "react-redux";
import NotFound from "../NotFound/NotFound";
import PagePreloader from "../../components/PagePreloader";
import sendRequest from "../../api";
import { Helmet } from "react-helmet";

import Colors from "../../components/utils/Colors";
import goBack from "../../assets/images/cart/goBack.svg";
import notFounded from "../../assets/images/notFoundSearch.svg";
import styles from "./BlogSingle.module.scss";
import SText from "../../components/SText";

import "./BlogSingle.css";

const BlogSingle = () => {
    const navigate = useNavigate();
    const [post, setPost] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const { url } = useParams();

    async function getContent() {
        const result = await sendRequest("getBlogData", { url: url });
        if (result && result !== "NO DATA") {
            setPost(result);
        }
        setLoaded(true);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getContent();
    }, [url]);

    if (loaded && !post) {
        return <NotFound />;
    }

    if (!loaded && !post) {
        return <PagePreloader />;
    }

    return (
        <div className={styles.wrapper}>
            <Helmet>
                <title>{post.title}</title>
                <meta
                    name="description"
                    content={post.title}
                    data-react-helmet="true"
                />
                <meta
                    name="keywords"
                    content={post.title}
                    data-react-helmet="true"
                />
            </Helmet>

            <div className={styles.header}>
                <div
                    onClick={() => navigate("/blog")}
                    className={styles.goBack}
                >
                    <img src={goBack} />
                </div>
            </div>

            <div className={styles.blogPage}>
                <h1>{post.title}</h1>

                <img
                    src={"https://api.ecomarket.ru" + post.image}
                    className={styles.blogPostImage}
                />
                <div
                    className="content"
                    dangerouslySetInnerHTML={{ __html: post.content }}
                ></div>
            </div>
        </div>
    );
};

export default BlogSingle;
